var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/profile"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('div',{class:[
          isActive && 'exact-active',
          isExactActive && 'exact-active',
          'icon-footer-mobile' ],attrs:{"role":"button"},on:{"click":navigate}},[_c('img',{attrs:{"src":require("../../assets/image/cluna/main_other_selected.png")}}),_c('img',{attrs:{"src":require("../../assets/image/cluna/main_other.png")}})])]}}])})],1),_c('li',[_c('router-link',{attrs:{"to":"/stores"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var href = ref.href;
          var route = ref.route;
          var navigate = ref.navigate;
          var isActive = ref.isActive;
          var isExactActive = ref.isExactActive;
return [_c('div',{class:[isActive && 'active', isExactActive && 'exact-active',
          'icon-footer-mobile' ],attrs:{"role":"button"},on:{"click":navigate}},[_c('img',{attrs:{"src":require("../../assets/image/cluna/main_tree_seleted.png")}}),_c('img',{attrs:{"src":require("../../assets/image/cluna/main_tree.png")}})])]}}])})],1),_c('li',[_c('router-link',{attrs:{"to":"/categories"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var href = ref.href;
          var route = ref.route;
          var navigate = ref.navigate;
          var isActive = ref.isActive;
          var isExactActive = ref.isExactActive;
return [_c('div',{class:[
          isActive && 'active',
          isExactActive && 'exact-active',
          'icon-footer-mobile' ],attrs:{"role":"button"},on:{"click":navigate}},[_c('img',{attrs:{"src":require("../../assets/image/cluna/main_cats_selected.png")}}),_c('img',{attrs:{"src":require("../../assets/image/cluna/main_cats.png")}})])]}}])})],1),_c('li',[_c('router-link',{attrs:{"to":"/orders"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var href = ref.href;
        var route = ref.route;
        var navigate = ref.navigate;
        var isActive = ref.isActive;
        var isExactActive = ref.isExactActive;
return [_c('div',{class:[
          isActive && 'active',
          isExactActive && 'exact-active',
          'icon-footer-mobile' ],attrs:{"role":"button"},on:{"click":navigate}},[_c('img',{attrs:{"src":require("../../assets/image/cluna/main_history_selected.png")}}),_c('img',{attrs:{"src":require("../../assets/image/cluna/main_history.png")}})])]}}])})],1),_c('li',[_c('router-link',{attrs:{"to":"/main"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var href = ref.href;
        var route = ref.route;
        var navigate = ref.navigate;
        var isActive = ref.isActive;
        var isExactActive = ref.isExactActive;
return [_c('div',{class:[isActive && 'active', isExactActive && 'exact-active', 'icon-footer-mobile' ],attrs:{"role":"button"},on:{"click":navigate}},[_c('img',{attrs:{"src":require("../../assets/image/cluna/main_home_selected.png")}}),_c('img',{attrs:{"src":require("../../assets/image/cluna/main_home.png")}})])]}}])})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }